import { ReactNode } from 'react'
import Navigation from '../Navigation'
import Footer from '../Footer'
import './Layout.css'

interface LayoutProps {
  children: ReactNode
}

function Layout({ children }: LayoutProps) {
  return (
    <div className='layout'>
      <div className='announcement-banner'>
        🚧 Runless is not yet available &mdash; interested? <a href='mailto:contact@cloudsoft.com.pl'>Contact us</a>
      </div>
      <Navigation />
      <main className='layout-main'>{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
